/**
 * Include your custom JavaScript here.
 */

const toggleRolexMobileNav = () => {
  const rolexMobileMenu = document.getElementById("rolex-mobile-menu");
  const arrowDown = document.getElementById("arrowDown");

  if (
    rolexMobileMenu.style.display === "none" ||
    rolexMobileMenu.style.display === ""
  ) {
    rolexMobileMenu.style.display = "block";
    arrowDown.style.transform = "rotate(180deg)";
  } else {
    rolexMobileMenu.style.display = "none";
    arrowDown.style.transform = "rotate(0)";
  }
};

function initMap() {
  mapboxgl.accessToken =
    "pk.eyJ1IjoibWljaGFlbC1leG9wcyIsImEiOiJjbGY3YW8zaXMxM2F2M3pvNDU4NTA0dWp2In0.f4go7U8Iw80rr7K5kKiuKg";

  const geojson = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: {
          message: "Foo",
          iconSize: [60, 60],
        },
        geometry: {
          type: "Point",
          coordinates: [0.897015023273145, 51.88968917755632],
        },
      },
    ],
  };

  const map = new mapboxgl.Map({
    container: "map", // container ID
    style: "mapbox://styles/mapbox/light-v11?optimize=true", // style URL
    center: [0.897015023273145, 51.88968917755632], // starting position [lng, lat]
    zoom: 15, // starting zoom
  });

  // Add markers to the map.
  for (const marker of geojson.features) {
    // Create a DOM element for each marker.
    const el = document.createElement("div");
    el.className = "marker";
    el.style.backgroundImage = `url(https://cdn.shopify.com/s/files/1/0050/4997/4856/files/rolex-map-marker.png?v=1676936702)`;
    el.style.width = `40px`;
    el.style.height = `40px`;
    el.style.backgroundSize = "100%";

    el.addEventListener("click", () => {
      window.alert(marker.properties.message);
    });

    // Add markers to the map.
    new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
  }
}

window.addEventListener("load", function () {
  var mapPlaceholder = document.getElementById("map");

  if (mapPlaceholder) {
    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          var script = document.createElement("script");
          script.src =
            "https://api.mapbox.com/mapbox-gl-js/v2.13.0/mapbox-gl.js";
          script.onload = function () {
            var mapboxCheckInterval = setInterval(function () {
              if (window.mapboxgl) {
                initMap();
                clearInterval(mapboxCheckInterval);
              }
            }, 100);
          };
          document.head.appendChild(script);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(mapPlaceholder);
  }
});

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// ROLEX VIDEO PLAYER WATCHMAKING 1

window.addEventListener("load", function () {
  // Create a variable to store the YouTube player
  let player;

  // This function creates an <iframe> (and YouTube player) after the API code downloads
  function onYouTubeIframeAPIReady() {
    player = new YT.Player("player", {
      videoId: "OE0E8BmrvnI",
    });
  }

  if(document.querySelector(".video-overlay")) {
      document.querySelector(".video-overlay").addEventListener("click", function () {
          if (player && typeof player.playVideo === "function") {
              player.playVideo(); // This plays the video
          }
          this.style.display = "none";
      });
  }

  if(document.querySelector(".video-overlay-2")) {
      document.querySelector(".video-overlay-2").addEventListener("click", function () {
        if (player && typeof player.playVideo === "function") {
          player.playVideo(); // This plays the video
        }
        this.style.display = "none";
      });
  }

  if(document.querySelector(".video-overlay-3")) {
    document
      .querySelector(".video-overlay-3")
      .addEventListener("click", function () {
        if (player && typeof player.playVideo === "function") {
          player.playVideo(); // This plays the video
        }
        this.style.display = "none";
      });
  }
});
